import * as React from 'react';
import { withStyles, WithStyles } from '@material-ui/core/styles';
import TranslateNew from '@translate/TranslateNew';
import { subscriptionStyle } from "./subscription.style";
import { connect } from 'react-redux';
import { ISubscription, SubscriptionPlatform } from '@app-types/websocket/subscription.types';
import Sub from './Sub';
import { IFamilyMember } from '@app-types/websocket/family.types';

const tn :TranslateNew = TranslateNew.getInstance();
const DAY_MS = 1000 * 60 * 60 * 24;
const CAMPAIGN_ALWAYS_DISPLAY_TIME_LEFT = 15 * DAY_MS;
const CAMPAIGN_DISPLAY_WHEN_OTHERS_EXPIRED_TIME_LEFT = 3 * DAY_MS;

interface IProps extends WithStyles<typeof subscriptionStyle> {
  accountId: number;
  subscriptions:ISubscription[];
  family:IFamilyMember[];
}

export function getDisplayedSubscriptions(subscriptions: ISubscription[], now: number = Date.now()): ISubscription[] {
  const allNonCampaignSubscriptionsExpired = subscriptions
    .filter((sub) => sub.platform !== SubscriptionPlatform.CAMPAIGN)
    .every((sub) => !hasTimeLeft(sub, now, 0));

  return subscriptions.filter((sub) => {
    if (sub.platform !== SubscriptionPlatform.CAMPAIGN) {
      return true;
    }
    if (hasTimeLeft(sub, now, CAMPAIGN_ALWAYS_DISPLAY_TIME_LEFT)) {
      return true;
    }
    return allNonCampaignSubscriptionsExpired
      && hasTimeLeft(sub, now, CAMPAIGN_DISPLAY_WHEN_OTHERS_EXPIRED_TIME_LEFT);
  });
}

function hasTimeLeft(subscription: ISubscription, now: number, timeLeft: number): boolean {
  return subscription.expirationTime !== undefined && subscription.expirationTime - now > timeLeft;
}


class SubscriptionSettings extends React.Component<IProps, {}> {
  
  public render() {
    const displayedSubscriptions = getDisplayedSubscriptions(this.props.subscriptions);
    return (
      <div>
        <span style={{ fontSize: '24px' }}>
          {tn.lang.settingsSubscriptionsHeader}
        </span>
        {displayedSubscriptions.map((sub, i) => <Sub key={i} subscription={sub} accountId={this.props.accountId} family={this.props.family} />)}
      </div>
    );
  }
}


function mapStateToProps(state: any) {
  const accountId = state.user.session.data.id;
  const subscriptions:ISubscription[] = state.subscriptions.subscriptions;
  const family:IFamilyMember[] = state.family.family;
  return {
    accountId,
    subscriptions,
    family,
  };
}


export default connect(mapStateToProps)(withStyles(subscriptionStyle)(SubscriptionSettings));



// WEBPACK FOOTER //
// ./src/components/subscription/SubscriptionSettings.tsx